import Vue from "vue";
import { mapGetters } from "vuex";

import checkboxComponent from "@/components/child/form/checkbox.vue";
import comboComponent from "@/components/child/form/combo.vue";
import dataTooltipComponent from "@/components/child/form/datatooltip.vue";
import dateTimePickerComponent from "@/components/child/form/datetimepicker.vue";
import decimalComponent from "@/components/child/form/decimal.vue";
import decimalComSinalCustomComponent from "@/components/child/form/decimalComSinalCustom.vue";
import fieldsetComponent from "@/components/child/form/fieldset.vue";
import { Component } from "@/decorators";
import ManipulacaoLoteEstoqueModel from "@/models/manipulacaoLoteEstoqueModel";
import ManipulacaoOrdemItemModel from "@/models/manipulacaoOrdemItemModel";
import ProdutoLoteModel from "@/models/produtoLoteModel";
import manipulacaoLoteEstoqueService from "@/services/manipulacaoLoteEstoqueService";
import ProdutoLoteService from "@/services/produtoLoteService";
import { Getters } from "@/store/store";
import { getProdutoLoteCombo } from "@/utils/common/combo/combotext";

import itemComponent from "./item.vue";

const produtoLoteService = new ProdutoLoteService();

@Component({
    components: {
        comboComponent,
        dataTooltipComponent,
        itemComponent,
        checkboxComponent,
        decimalComponent,
        decimalComSinalCustomComponent,
        fieldsetComponent,
        dateTimePickerComponent,
    },
    computed: {
        ...mapGetters(["GET_IS_FRACIONAMENTO", "GET_IS_ESTEREIS"] as Getters),
    },
})
export default class LoteEstoqueComponent extends Vue {
    // State computed props
    GET_IS_FRACIONAMENTO: () => Promise<boolean>;
    GET_IS_ESTEREIS: () => Promise<boolean>;

    isFracionamento = false;
    isEstereis = false;

    private model: ManipulacaoOrdemItemModel[] = null;
    private produtosParaVerificacao: ManipulacaoLoteEstoqueModel[] = [];
    private produtoLoteOptions: {
        value: number | undefined;
        text: string;
        produtoId: number;
        quantidadeAtual: number;
    }[] = [];

    private isCarregado = false;

    private movimentacaoEstoqueId?: number;
    private manipulacaoOrdemId?: number;

    private async mounted() {
        this.isFracionamento = await this.GET_IS_FRACIONAMENTO();
        this.isEstereis = await this.GET_IS_ESTEREIS();
    }

    public clear() {
        this.model = new Array<ManipulacaoOrdemItemModel>();
        this.produtosParaVerificacao = new Array<ManipulacaoLoteEstoqueModel>();
    }

    public async loadModel(estoqueId?: number, movimentacaoEstoqueId?: number, manipulacaoOrdemId?: number) {
        this.movimentacaoEstoqueId = movimentacaoEstoqueId;
        this.manipulacaoOrdemId = manipulacaoOrdemId;

        const data = await produtoLoteService
            .getLotesDisponiveis(
                this.produtosParaVerificacao.map(p => p.produtoId),
                estoqueId,
            )
            .withLoading()
            .resolveWithJSON<ProdutoLoteModel[]>();

        const exibeCodigo = this.isFracionamento || this.isEstereis;
        this.produtoLoteOptions = data.map(item => ({
            ...getProdutoLoteCombo(item, exibeCodigo),
            produtoId: item.produtoId,
            quantidadeAtual: item.quantidadeAtual,
        }));

        await this.loadModelInternal().withLoading();
    }

    private async onChangeItem(model: ManipulacaoLoteEstoqueModel, index: number) {
        this.$emit("updateProdutoLoteItens", model);
    }

    private async loadModelInternal() {
        this.clear();

        this.produtosParaVerificacao = await manipulacaoLoteEstoqueService.listProdutosMovimentosVerificados(
            this.manipulacaoOrdemId,
        );

        this.isCarregado = true;
    }
}
